import React from "react";
import NewAddress from "./Loadable";
import { NewAddressWrapper } from "wrapper/NewAddressWrapper";


export const NewAddresspage = () => (
  <NewAddressWrapper>
    <NewAddress />
  </NewAddressWrapper>
  );
